export const COMPANY_NAME = "Thrive";
export const COMPANY_ABOUT = "Stay connected and enhance your English learning journey! Subscribe to our newsletter for exclusive content, updates, and special offers.";
export const COMPANY_EMAIL = "info@example.com";
export const COMPANY_PHONE_NUMBER = "(+21) 123 456 586"
export const COMPANY_ADDRESS = "123 Main Street, Cityville, Country XYZ.";
export const LOGO_IMG_1 = require('./assets/logo-1.jpg');
export const LOGO_IMG_2 = require('./assets/logo-2.jpg');
export const OUR_COMPANY_TEXT = "Our Company"
export const OUR_COURSES_TEXT = "Our Courses";
export const NAV_LINKS = [
    { text: "Home", path: "/" },
    { text: "Courses", path: "/courses" },
    { text: "Pricing Plan", path: "/pricing-plan" },
    { text: "About", path: "/about" }
];

export const NAVLINK_CONTACT_US = {
    path: "/contact",
    text: "Contact Us"
}

export const HERO_TYPING_TITLE = [
    "Polish Your English Proficiency.",
    "Master the Art of Spoken English.",
    "Refine Your English Communication.",
    "Enhance Your English Speaking Skills.",
    "Speak English Fluently with Confidence.",
    "Improve Your English Pronunciation.",
    "Unlock the Power of Fluent English.",
    "Excel in Conversational English.",
    "Elevate Your Spoken English Ability.",
    "Speak English Naturally and Effectively."
];

export const HERO_SUB_HEADING = "Embark on a Journey of Discovery and Growth: Where Learning Meets Innovation, Inspiring You to Explore, Engage, and Excel in Every Endeavor."

export const COURSE_TITLE = "Courses"
export const COURSE_SUB_HEADING = "Crestest offers a wide range of preparatory courses";

export const FEATURE_TITLE = "Features"
export const FEATURE_SUB_HEADING = "Unleash the Full Potential of Thrive with These Cutting-edge Features";
export const PRICING_SECTION_TITLE = "Our Pricing Plans";
export const PRICING_SECTION_SUBTITLE = "Choose the perfect plan for your English learning journey.";


export const ABOUT_TITLE = "About Us";
export const ABOUT_SUB_HEADING = "Empowering Futures, Enriching Minds: Discover Our Story"
export const aboutUsPoints = [
    "Innovating education solutions.",
    "Lifelong learning advocates.",
    "Passionate community builders.",
    "Education landscape transformers."
];

export const WHY_US_TITLE = "Why Choose Us";
export const WHY_US_SUB_TITLE = "Elevate Your Experience: Unveiling Our Unique Advantages and Commitment";

export const WHY_CHOOSE_US_POINT1 = {
    title: "Exceptional Quality",
    description: "Experience unparalleled quality in education delivery and support services."
}
export const WHY_CHOOSE_US_POINT2 = {
    title: "Personalized Approach",
    description: "Benefit from tailored learning paths and personalized guidance for every learner."
}
export const WHY_CHOOSE_US_POINT3 = {
    title: "Community Engagement",
    description: "Join a vibrant community of learners, educators, and mentors for collaborative growth."
}

export const FACULTY_TITLE = 'Faculty Excellence'
export const FACULTY_SUB_TITLE = 'Meet Our Distinguished Educators and Researchers'

export const FAQ_TITLE = "FAQ"
export const FAQ_SUB_TITLE = "Explore answers to common inquiries about our educational platform"

export const SUCCESS_STORIES_TITLE = "Inspiring Success Stories"
export const SUCCESS_STORIES_SUB_TITLE = "Discover How Our Students Mastered Spoken English"

export const SUBSCRIBE_TITLE = "Subscribe";
export const SUBSCRIBE_SUBTITLE = "Share your email id for regular updates.";
export const SUBSCRIBE_PLACEHOLDER = "Enter your email";
export const SUBSCRIBE_BUTTON_TEXT = "Subscribe"

export const DATA_CHAPTERS = "Lessons";
export const DATA_QUESTIONS = "Practice Questions";
export const DATA_NOTES = "Study Materials";
export const DATA_CONCEPT_MAP = "Language Map";
export const TOTAL_CHAPTERS = 521;
export const TOTAL_QUESTIONS = 49647;
export const TOTAL_NOTES = 4963;
export const TOTAL_CONCEPT_MAP = 827;

export const BOOK_DEMO_TITLE = "Why Thrive is a best option?"
export const BOOK_DEMO_DESCRIPTION = "Thrive is a platform where we provide live sessions at a very affordable cost so that everyone can enroll here to improve their communication skills."
export const BOOK_DEMO_BUTTON_TEXT = "Book Demo"

export const CONTACT_US_TITLE = "Get in Touch";
export const CONTACT_US_SUBTITLE = "We're here to answer any questions you may have. Reach out to us and we'll respond as soon as we can.";
export const CONTACT_US_FORM_TITLE = "We'd love to hear from you! Let's get in touch"

//images
export const BG_IMG_1 = require('./assets/240_F_170055665_0wz6obwYZ3rk0m788vuIEk8WzIscfgVV.jpg');
export const BG_IMG_2 = require('./assets/1.geometric-science-education-background-vector-gradient-blue-digital-remix_53876-125993.jpg');
export const BG_IMG_3 = require('./assets/240_F_375321407_3CC7tryBap2FFbKCPYHlCvvjZ72Kw1up.jpg');
export const BG_IMG_4 = require('./assets/360_F_278522831_zqEbgmXc5QiQReIbytqggcRLTGdp8cix.jpg');
export const BG_IMG_5 = require('./assets/pngtree-school-supplies-graduation-cap-border-blackboard-education-background-picture-image_1219927.jpg');
export const BG_IMG_6 = require('./assets/science-technology-engineering-math-blue-frame_104589-263.avif');
export const ABOUT_IMG = require('./assets/5836-removebg-preview.png');
export const ABOUT_SVG = require('./assets/undraw_educator_re_ju47.svg');
export const SECTION_BG_IMG = require('./assets/uniquefeatures-bg.jpg');
export const CHAPTERS_ICON = require('./assets/list.png');
export const QUESTIONS = require('./assets/question-mark.png');
export const NOTES = require('./assets/pencil.png');
export const CONCEPT_MAPS = require('./assets/circuit.png');
export const BOOK_DEMO_BG = require('./assets/photo-1522199899308-2eef382e2158.avif');
export const BOOK_DEMO_IMG = require('./assets/pexels-anna-shvets-4226122.jpg');